import { createSlice } from '@reduxjs/toolkit';
import { useSelector } from 'react-redux';

const mapsApiKey = createSlice({
	name: 'mapsApiKey',
	initialState: '',
	reducers: {
		mapsApiKeyAdded(state, action) {
			return action.payload;
		}
	}
});

export const { mapsApiKeyAdded } = mapsApiKey.actions;

export const useMapsApiKey = () => useSelector((state) => state.mapsApiKey);

export default mapsApiKey.reducer;
